const react = require('react')


export const resolve = {
        react
}
